<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <!-- <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i> -->
        <!-- <input
					type="text"
					class="form-control form-control-sm w-250px ps-13"
					placeholder="Search users..."
					[value]="searchTerm"
					(input)="onSearch($event)"
					[disabled]="isLoading" />
				<button
					*ngIf="searchTerm"
					type="button"
					class="btn btn-sm btn-icon btn-light position-absolute end-0 me-2"
					(click)="clearSearch()"
					[disabled]="isLoading">
					<i class="ki-duotone ki-cross fs-3">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</button> -->
      </div>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-table-toolbar="base" [class.d-none]="hasSelectedItems">
        <button type="button" class="btn btn-sm btn-outline me-3 text-nowrap"
          [ngClass]="showFiltersForm ? 'btn-primary' : 'btn-dark'" (click)="toggleFiltersForm()">
          <i class="ki-duotone fs-2" [ngClass]="showFiltersForm ? 'ki-minus' : 'ki-filter'">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
        </button>
        <button type="button" class="btn btn-sm btn-dark me-3 text-nowrap" data-bs-toggle="modal"
          data-bs-target="#kt_modal_add_user">
          <i class="ki-duotone ki-plus fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Add New Agent</span>
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center" data-table-toolbar="selected"
        [class.d-none]="!hasSelectedItems">
        <div class="fw-bold me-5">
          <span class="me-2">{{ selectedUserIds.size }}</span>Selected
        </div>
        <button type="button" class="btn btn-sm btn-danger" (click)="onBulkDelete()" [disabled]="isDeleting">
          <i class="ki-duotone ki-trash fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
            <span class="path4"></span>
            <span class="path5"></span>
          </i>
          <span>Delete Selected</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-header border-0 pt-0" *ngIf="showFiltersForm">
    <div class="card-form fw-row row">
      <div class="col-md-3 mb-10">
        <label class="form-label fs-6 fw-semibold w-100">Agent Type</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.is_primary_agent">
          <option value="">All Agents</option>
          <option value="primary">Primary Agent</option>
          <option value="secondary">Secondary Agent</option>
        </select>
      </div>
      <div class="col-md-3 mb-10">
        <label class="form-label fs-6 fw-semibold w-100">Primary Agent</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.primary_agent">
          <option value="">Select Primary Agent</option>
          <option *ngFor="let agent of primaryAgentOptions" [value]="agent.value">{{ agent.label }}</option>
        </select>
      </div>
      <div class="col-md-4 mb-10">
        <label class="form-label fs-6 fw-semibold w-100">Search</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.search"
          placeholder="Email, Login ID, Name, City, Phone, Country" />
      </div>
      <div class="col-md-2 mb-10">
        <label class="form-label fs-6 fw-semibold w-100">&nbsp;</label>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-primary text-nowrap" (click)="applyFilters()">
            <span>Apply</span>
          </button>
          <button type="button" class="btn btn-sm btn-dark text-nowrap" (click)="clearAllFilters()">
            <span>Clear All</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body py-4">
    <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_agents">
      <thead>
        <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
          <th class="w-10px pe-2">
            <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
              <input class="form-check-input" type="checkbox" [checked]="isAllSelected" (click)="toggleSelectAll()" />
            </div>
          </th>
          <th class="min-w-125px">User</th>
          <th class="min-w-125px">Role</th>
          <th class="min-w-125px">Last login</th>
          <th class="min-w-125px">Agent Status</th>
          <th class="min-w-125px">Agent Type</th>
          <th class="min-w-125px">Company Agent</th>
          <th class="min-w-125px">Primary Agent</th>
          <th class="min-w-125px">Status</th>
          <th class="min-w-125px">Joined Date</th>
          <th class="min-w-100px">Actions</th>
        </tr>
      </thead>
      <tbody class="text-gray-600 fw-semibold">
        <!-- Loading State -->
        <tr *ngIf="isLoading">
          <td colspan="7" class="text-center py-5">
            <div class="d-flex align-items-center justify-content-center">
              <span class="spinner-border spinner-border-sm me-2"></span>
              <span class="text-gray-600">Loading users...</span>
            </div>
          </td>
        </tr>

        <!-- Empty State -->
        <tr *ngIf="!isLoading && users.length === 0">
          <td colspan="7" class="text-center py-5">
            <div class="d-flex flex-column align-items-center">
              <i class="ki-duotone ki-user fs-3x text-gray-400 mb-3">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <span class="text-gray-600 fs-6">
                {{ searchTerm ? 'No users found matching your search.' : 'No users found.' }}
              </span>
              <button *ngIf="searchTerm" type="button" class="btn btn-sm btn-light mt-3" (click)="clearSearch()">
                Clear Search
              </button>
            </div>
          </td>
        </tr>

        <!-- User Rows -->
        <tr *ngFor="let user of users; trackBy: trackByUserId">
          <td>
            <div class="form-check form-check-sm form-check-custom form-check-solid">
              <input class="form-check-input" type="checkbox" [value]="user._id || user.doc_id"
                [checked]="isSelected(user._id || user.doc_id || '')"
                (change)="toggleSelection(user._id || user.doc_id || '')" />
            </div>
          </td>
          <td class="d-flex align-items-center">
            <div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
              <a [routerLink]="['/common','admin-users','user-detail']">
                <div class="symbol-label" *ngIf="getAvatarDisplay(user).type === 'image'">
                  <img [src]="getAvatarDisplay(user).value" [alt]="user.name || user.email" class="w-100" />
                </div>
                <div *ngIf="getAvatarDisplay(user).type === 'initial'" class="symbol-label fs-3"
                  [ngClass]="getAvatarDisplay(user).bgClass">
                  {{ getAvatarDisplay(user).value }}
                </div>
              </a>
            </div>
            <div class="d-flex flex-column">
              <a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">
                {{ user.name || user.email || 'Unknown User' }}
              </a>
              <span>{{ user.email || '' }}</span>
            </div>
          </td>
          <td>{{ user.role_name || user.designation || 'No Role' }}</td>
          <td>
            <div class="badge fw-bold" [ngClass]="(user.last_login | lastLogin).class">
              {{ (user.last_login | lastLogin).text }}
            </div>
          </td>
          <td>
            <div class="badge fw-bold" [ngClass]="user.is_verified ? 'badge-light-success' : 'badge-light-danger'">
              {{ user.is_verified ? 'Verified' : 'Not Verified' }}
            </div>
          </td>
          <td>
            <div class="badge fw-bold"
              [ngClass]="user.is_primary_agent ? 'badge-light-success' : 'badge-light-warning'">
              {{ user.is_primary_agent ? 'Primary' : 'Secondary' }}
            </div>
          </td>

          <td>{{ user.company_agent?.name || '-' }}</td>
          <td>{{ !user.is_primary_agent && user.primary_agent_info? (user.primary_agent_info.title + ' ' +
            user.primary_agent_info.name) : '-' }}</td>

          <td>
            <div class="badge fw-bold" [ngClass]="user.status === 'permitted' ? 'badge-light-success' : 'badge-light-danger'">
              {{ user.status === 'permitted' ? 'Permitted' : 'Blocked' }}
            </div>
          </td>

          <td>{{ user.created_at | relativeDate }}</td>
          <td class="text-end">
            <div class="d-flex justify-content-end gap-2">
              <!-- Edit Icon -->
              <button type="button" class="btn btn-sm btn-icon btn-light-primary" (click)="editUser(user)"
                title="Edit Admin User">
                <i class="ki-duotone ki-pencil fs-5">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>

              <button type="button" class="btn btn-sm btn-icon btn-light-success"
                *ngIf="!user.is_verified && ((loggedInUser && loggedInUser.role_complete && loggedInUser.role_complete.permissions.agents && loggedInUser.role_complete.permissions.agents['can-verify']) || loggedInUser.role_complete.is_admin)"
                (click)="verifyUser(user)" title="Verify Admin User">
                <i class="ki-duotone ki-verify fs-5">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>

              <!-- Delete Icon -->
              <!-- <button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="deleteNewsLetter(newsLetter)"
                title="Delete News Letter">
                <i class="ki-duotone ki-trash fs-5">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                  <span class="path5"></span>
                </i>
              </button> -->
            </div>
          </td>
          <!-- <td class="">
            <a href="#" class="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
              data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
              <i class="ki-duotone ki-down fs-5 ms-1"></i></a>
            <div
              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
              data-kt-menu="true">
              <div class="menu-item px-3">
                <a href="#" class="menu-link px-3" (click)="editUser(user); $event.preventDefault()">Edit</a>
              </div>
              <div class="menu-item px-3">
                <a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
              </div>
            </div>
          </td> -->
        </tr>





      </tbody>
    </table>
  </div>

  <!-- Pagination Component -->
  <app-pagination [paginationInfo]="paginationInfo" [loading]="isLoading" (pageChange)="onPageChange($event)">
  </app-pagination>
</div>
